<template>
  <section class="professional-experience">
    <ExperienceTemplate :pageTitle="$t('professional-experience.professional-experience')"
      :Experiences="ProfessionalExperience" :experienceIcon="professionalImage" />
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ProfessionalExperienceEn from '@/components/Helpers/About/ProfessionalExperience/ProfessionalExperienceEn.js';
import ProfessionalExperiencePt from '@/components/Helpers/About/ProfessionalExperience/ProfessionalExperiencePt.js';
import ExperienceTemplate from '@/components/Helpers/ExperienceTemplate.vue'
import professionalImage from "@/assets/about/professional_experience.png"

const ProfessionalExperience = ref(null);

onMounted(() => {
  const userLanguage = navigator.language || navigator.userLanguage;

  if (userLanguage.startsWith("pt")) {
    ProfessionalExperience.value = ProfessionalExperiencePt;
  }
  else {
    ProfessionalExperience.value = ProfessionalExperienceEn;
  }
});
</script>

<style scoped>
.professional-experience {
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-top: -40px;
  margin-bottom: -10px;
  padding-bottom: 20px;
}
</style>
